import _ from "lodash";
import * as z from "../../../framework";
import * as ui from "../../core/ui";

export default class UserDashboards {

    private grid: ui.Grid;
    private screens: any[];
    private options: any;

    public lookerEnabled(): boolean {
        return z.util.getBooleanOption("LookerEnabled", false);
    }

    public init(options: {
        userId?: number,
        screen?: any,
        screenId?: number,
        setRefreshPageOnExit?: any
    }) {
        let me = this;

        me.options = options || {};
        me.screens = _.orderBy(this.getScreens(), "CodeNumber");

        me.initScreenDropdown();
        me.initInsertTabs();
        me.initGrid();
        me.initGridDeleteButton();
    }

    public setUsersDashboards(userId: any, callback?: any) {
        let me = this;
        me.options.userId = userId;

        z.ajax({
            url: `Dashboard/GetUsersAccessibleDashboards?userId=${userId}`,
        }).done(function (response) {
            let results = response.d.results;
            window.z.usersAccessibleDashboards = results;

            me.get("#AvailableDashboards").data("kendoDropDownList").setDataSource(results);
        }).always(function (response) {
            if (callback) {
                callback(response);
            }
        });
    }

    private get(selector: string) {
        let me = this;

        return me.options.screen
            ? me.options.screen.get(selector)
            : $(selector);
    }

    private getScreens() {
        let screens = _.filter(z.codes.Screen, s => s.IsDeleted === false);
        _.each(screens, function (screen) {
            screen.CodeNumber = z.util.enforceCapitalization(screen.CodeNumber);
        });

        return _.orderBy(screens, s => s.CodeNumber);
    }

    private initScreenDropdown() {
        let me = this;

        me.get("#ScreenName").data("kendoDropDownList").setDataSource(this.screens as any);
    }

    private initInsertTabs() {
        let me = this,
            screenId, key; // save for use in insertedSuccessfully

        me.get("#InsertLookerDashboard").data("me").initialize({
            setupObservable: function (observable) {
                observable.set("UserId", me.options.userId);
                observable.set("SortOrder", 1);
            },
            deleteDtoProperties: function (dto) {
                dto.ScreenId = dto.Screen && dto.Screen.Id;
                dto.LookerKey = dto.Dashboard && dto.Dashboard.LookerKey;

                screenId = dto.ScreenId;
                key = dto.LookerKey;

                delete dto.Screen;
                delete dto.Dashboard;

                return dto;
            },
            insertedSuccessfully: function (response) {
                z.controls.alert({
                    type: "success",
                    header: z.ll("SaveSuccessful"),
                    message: z.ll("DashboardCreatedMessage")
                });

                me.get("#SPDashboardsGrid").data("kendoGrid").dataSource.read();

                if (me.options.userId == z.user.loginData.UserId) {
                    let screensWithDashboards = (localStorage
                        && localStorage.ScreensWithLookerDashboards
                        && JSON.parse(localStorage.ScreensWithLookerDashboards)) || [];

                    if (!_.find(screensWithDashboards, screenId)) {
                        screensWithDashboards.push(screenId);
                        localStorage.setItem("ScreensWithLookerDashboards", JSON.stringify(screensWithDashboards));
                    }

                    if (me.options.screenId
                        && me.options.screenId == screenId
                        && me.options.setRefreshPageOnExit) {

                        me.options.setRefreshPageOnExit(true);
                    }
                }
            }
        });
    }

    private initGrid() {
        let me = this;

        me.grid = me.get("#SPDashboardsGrid").data("me") as ui.Grid;
        me.grid.build({
            id: "SPDashboardsGrid",
            entity: "Dashboard",
            autoBind: false,
            editButton: false,
            deleteButton: true,
            editOnDoubleClick: false,
            height: 349,
            alwaysSelect: [
                "*"
            ],
            filter: function () {
                return `UserId eq ${me.options.userId}`;
            },
            gridColumns: [
                {
                    field: "Title",
                    title: z.ll("TitleNoColon"),
                    sortable: false,
                    filterable: false,
                    template: "# let match =  _.find(z.usersAccessibleDashboards, s => s.LookerKey == data.LookerKey); #" +
                        "#= match ? match.Title : '---' #"
                },
                {
                    field: "Screen",
                    title: z.ll("Screen"),
                    template: "#: _.find(z.codes.Screen, s => s.Id == data.ScreenId).CodeNumber #",
                    sortable: false,
                    filterable: false
                },
                {
                    field: "SortOrder",
                    title: z.ll("SortOrder"),
                    template: "#: data.SortOrder #"
                }
            ]
        });
    }

    private initGridDeleteButton() {
        let me = this;

        me.get("#SPDashboardsGrid").tie("click", ".k-grid-delete", function () {
            let selectedDashboard = me.grid.selectedItem;
            if (selectedDashboard) {
                z.util.deleteEntity({
                    id: selectedDashboard.Id,
                    entity: "Dashboard",
                    checkDelete: false,
                    deleteMessage: "DeleteDashboardConfirmation",
                    success: function () {
                        if (me
                            && me.options
                            && me.options.setRefreshPageOnExit
                            && me.options.screenId == selectedDashboard.ScreenId
                            && me.options.userId == z.user.loginData.UserId) {

                            me.options.setRefreshPageOnExit(true);
                        }

                        me.get("#SPDashboardsGrid").data("kendoGrid").dataSource.read();
                    }
                });
            }
        });
    }
}
